module.exports = __webpack_public_path__ + "assets/img/lo.8032ad36.png";